import { CommonTabbarState, TabRoute } from '@/global/components/common-tabbar';
import './index.less'
import { useContext, useEffect, useState } from 'react';
import { CommonTabbarContext, SystemContext } from '@/App';
import { useParams } from 'react-router-dom';
import { SystemStatus } from '@/global/store/system-store';
import { MonitorObject } from '@/global/interface/monitor-object/monitor-object';
import { getMonitorObjectById, updateMonitorObject } from '@/api/monitor-object/monitor-object';
import { TAB_TYPE } from '@/enums/tab-type';
import TnMessage from '@/global/components/message';
import { emitter } from '@/global/listeners';
import { Emit_Event } from '@/enums/emit-event';
import { Skeleton, Switch } from 'antd';
import TnInput from '@/global/components/input/tn-input';

/**
 * 监测对象详情页
 */
export default function MonitorObjectDetail() {
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext);
    const { monitorObjectId } = useParams()
    const systemContext = useContext<SystemStatus>(SystemContext); // system上下文
    const [loading, setLoading] = useState<boolean>(false); // 加载状态
    const [item, setItem] = useState<MonitorObject>(); // 监测对象

    useEffect(() => {
        if (!monitorObjectId) return;
        // 获得监测对象详情
        setLoading(true);
        getMonitorObjectById(+monitorObjectId).then(res => {
            let data: MonitorObject = res.data;
            setItem(data);
            // 新增页签
            let addTab: TabRoute = {
                title: `${data.name}` || '',
                url: `${TAB_TYPE.MONITOR_OBJECT}/${monitorObjectId}`,
                closable: true
            }
            commonTabbarContext.pushRoute(addTab)
        }).catch(err => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("获得监测对象详情失败")
            }
        }).finally(() => {
            setLoading(false);
        })

    }, [monitorObjectId, systemContext.needRenderTab])

    // 打开监测参数详情
    const onOpenMonitorParameterDetail = (monitorParameterId: number) => {
        commonTabbarContext.navigate(`${TAB_TYPE.MONITOR_PARAMETER}/${monitorParameterId}`)
    }

    // 保存监测对象详情
    const onSaveDetail = () => {
        updateMonitorObject(+monitorObjectId, item).then(res => {
            TnMessage.success("更新成功");
            emitter.emit(Emit_Event.UPDATE_MONITOR_OBJECT, item);
        }).catch(err => {
            TnMessage.error("更新失败");
        })
    }

    // 编辑了监测对象信息
    const onChangeInfo = (key: string, value) => {
        item[key] = value;
        setItem({ ...item });
    }


    if (item == null) {
        return (
            <div></div>
        )
    }

    return (
        <div className="monitor-object-detail">
            <Skeleton loading={loading}>
                <div className="item">
                    <div className="label">名称</div>
                    <TnInput value={item.name} style={{ width: '240px' }} onTextChange={(value) => onChangeInfo('name', value)} />
                </div>
                <div className="item">
                    <div className="label">建筑功能</div>
                    <TnInput value={item.archiFunction} style={{ width: '100%' }} onTextChange={(value) => onChangeInfo('archiFunction', value)} />
                </div>
                <div className="item">
                    <div className="label">材料类别</div>
                    <TnInput value={item.materialType} style={{ width: '240px' }} onTextChange={(value) => onChangeInfo('materialType', value)} />
                </div>
                <div className="item">
                    <div className="label">材料牌号</div>
                    <TnInput value={item.materialGrade} style={{ width: '240px' }} onTextChange={(value) => onChangeInfo('materialGrade', value)} />
                </div>
                <div className="item">
                    <div className="label">
                        开启
                    </div>
                    <div className="text-value">
                        <Switch className="change-switch" value={item?.start || false} onChange={() => onChangeInfo('start', !item?.start)} />
                    </div>
                </div>
                <div className="item param-dq-row">
                    <div className="label">监测参数编号</div>
                    <div className="label">监测参数名称</div>
                    <div className="label">监测参数代号</div>
                    <div className="label">操作</div>
                    <div className="label">操作</div>
                    <div className="label">当前状态</div>
                </div>
                {item.rootMonitorParameters.map(param => (
                    <div className="item param-dq-row">
                        <div className="text-value">{param.encoding || ''}</div>
                        <div className="text-value">{param.name || ''}</div>
                        <div className="text-value">{param.code || ''}</div>
                        <div className="btn-block"><div className="open-detail-btn"><span>数据显示</span></div></div>
                        <div className="btn-block"><div className="open-detail-btn" onClick={() => onOpenMonitorParameterDetail(param.id)}><span>参数详情</span></div></div>
                        <div className="text-value"></div>
                    </div>
                ))}
                <div style={{ flex: '1 1 auto' }}></div>
                <div className="primary-btn" onClick={onSaveDetail}><div className="text">保存</div></div>
            </Skeleton>
        </div>
    )

}